import { Inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { ProfileInput } from '../profile';
import { ProfileService } from '../services/profile.service';
import { ProfileBaseGuard } from './profile-base.guard';
import { ProfileFlagsService } from '@app/profile/services/profile-flags.service';

/**
 * Route guard to control the accessibility of the /profile/:id/insights/skillcareer route
 */
@Injectable({
  providedIn: 'root',
})
export class ProfileSkillCareerGuard extends ProfileBaseGuard {
  constructor(
    private profileFlagsService: ProfileFlagsService,
    @Inject('profileInput') protected profileInput: ProfileInput,
    protected profileService: ProfileService,
    protected router: Router
  ) {
    super(profileInput, router, profileService);
    this.isAuthorized = this.hasFeature;
  }

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {
    const ownerAuthorized =
      this.isAuthorized &&
      this.profileService.ownerAuthorizedForGuard(route.parent);

    if (!ownerAuthorized) {
      const parentUrl = super.getParentUrl(route, state);
      return this.router.parseUrl(`${parentUrl}skills`);
    } else {
      return ownerAuthorized;
    }
  }

  private get hasFeature(): boolean {
    return this.profileFlagsService.showPersonalSkillInsights;
  }
}
